<template>
  <div>
    <HeroHeader
      eyebrow="Propiedades"
      title="Locales activos"
      :counter-num="filteredList.length"
      counter-unit="en total"
    >
      <template #toolbar>
        <button class="btn" @click="showNewSidebar = true">+ Agregar</button>
      </template>
    </HeroHeader>

    <div class="filter-bar">
      <SearchInput v-model="search" placeholder="Buscar por nombre, dirección o propietario…"/>
      <SortSelect :options="sortOptions" v-model="sortBy" />
    </div>

    <div v-if="filteredList.length > 0">
      <div
        v-for="o in filteredList"
        :key="o.id"
        class="tenant-row tenant-row--clickable"
        @click="$router.push({name:'estate-detail',params:{id:o.id}})"
      >
        <div class="tenant-row__body">
          <div class="tenant-row__name">{{ o.description }}</div>
          <div class="tenant-row__meta">{{ [o.address, o.owner].filter(Boolean).join(' · ') || '—' }}</div>
        </div>
        <div class="tenant-row__actions">
          <span class="dt-icon" title="Expositores"
                @click.stop="$router.push({name:'tenants',query:{estateId:o.id,estateName:o.description}})">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </span>
          <span class="dt-icon" title="Impuestos"
                @click.stop="$router.push({name:'estate-detail',params:{id:o.id},query:{tab:'taxes'}})">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
            </svg>
          </span>
          <span class="dt-icon" title="Editar" @click.stop="showUpdateSidebar = true; sidebarData = o">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
          </span>
        </div>
      </div>
    </div>

    <EmptyState v-else title="Sin propiedades" message="No hay propiedades para mostrar."/>

    <NewEstate @add="addRow" @close="showNewSidebar = false"
               :class="{'show': showNewSidebar}" title="Nueva propiedad" :show-navbar="showNewSidebar"/>
    <UpdateEstate :data="sidebarData" @update="updateRow" @close="showUpdateSidebar = false"
                  :class="{'show': showUpdateSidebar}" title="Editar propiedad" :show-navbar="showUpdateSidebar"/>
  </div>
</template>

<script>
import NewEstate from './NewEstate'
import UpdateEstate from './UpdateEstate'
import HeroHeader from '@/components/HeroHeader'
import EmptyState from '@/components/EmptyState'
import SortSelect from '@/components/SortSelect'
import SearchInput from '@/components/SearchInput'
import { sortItems } from '@/utils/sort'
import { db } from '@/firebase/firebaseConfig'

export default {
  name: 'Estates',
  components: { NewEstate, UpdateEstate, HeroHeader, EmptyState, SortSelect, SearchInput },
  data () {
    return {
      list: [],
      search: '',
      sortBy: 'name',
      sortOptions: [
        { value: 'name', label: 'Nombre (A–Z)', field: 'description', type: 'string', dir: 'asc' },
        { value: 'name_desc', label: 'Nombre (Z–A)', field: 'description', type: 'string', dir: 'desc' },
        { value: 'recent', label: 'Más recientes', field: 'createdAt', type: 'date', dir: 'desc' },
        { value: 'oldest', label: 'Más antiguas', field: 'createdAt', type: 'date', dir: 'asc' }
      ],
      showNewSidebar: false,
      showUpdateSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    filteredList () {
      let items = this.list
      const q = this.search.trim().toLowerCase()
      if (q) {
        items = items.filter(o =>
          (o.description || '').toLowerCase().includes(q) ||
          (o.address || '').toLowerCase().includes(q) ||
          (o.owner || '').toLowerCase().includes(q)
        )
      }
      return sortItems(items, this.sortOptions.find(o => o.value === this.sortBy))
    }
  },
  async created () {
    try {
      this.$store.dispatch('showProgress')
      const snap = await db.collection('estates').orderBy('createdAt').get()
      snap.forEach(doc => this.list.push({ id: doc.id, ...doc.data() }))
    } catch (e) {
      this.$toast.error('Error al cargar propiedades')
    } finally {
      this.$store.dispatch('hideProgress')
    }
  },
  methods: {
    addRow (obj) { this.list.unshift(obj) },
    updateRow (o) {
      const idx = this.list.findIndex(d => d.id === o.id)
      if (idx !== -1) Object.assign(this.list[idx], o)
    }
  }
}
</script>
